// extracted by mini-css-extract-plugin
export default {"content":"gmt1cYfo_7M0HCbUC0PF"};